import { TeamMessage } from "../../../../model/chats/TeamConversationMessageModel";

const TeamChatsProvider = new (class TeamChatsProvider {
  groupByDate = (messages: TeamMessage[]) => {
    return messages.reduce<Record<string, TeamMessage[]>>((acc, msg) => {
      const date = msg?.create_date!.toString().split(" ")[0];
      if (!acc[date]) acc[date] = [];
      //acc[date].push(msg);
      acc[date] = [msg, ...acc[date]];
      return acc;
    }, {});
  };
})();

export default TeamChatsProvider;
